<template>
	<div class="wais">
		<div class="wai">
			<div class="title">
				<div class="blue"></div>
				<div style="flex: 1;">分享海报</div>
			</div>
			<el-form label-width="120px">
				<el-form-item label="分享海报上传">
					<div style="display: flex;" class="list1">
						<upload v-model="imgurl" style="width:130px;height:117px;"></upload>
						<div>
							<el-button size="small"> 选择文件 </el-button>
							<p>建议尺寸750*1334，JPG、PNG格式， 图片小于1M </p>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="用户头像与昵称" style="margin-top: 20px;">
					<p class="heads">用户头像是否显示</p>
					<el-radio v-model="userhead" label="1">是</el-radio>
					<el-radio v-model="userhead" label="2">否</el-radio>
					<p class="heads" style="margin-top:40px;">用户昵称字体颜色</p>
					<el-radio v-model="usercolor" label="1">是</el-radio>
					<el-radio v-model="usercolor" label="2">否</el-radio>
				</el-form-item>
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">分享获益</div>
				</div>
				<el-form-item>
					<div>
						<el-radio v-model="userget" label="1">无</el-radio>
					</div>
					<div style="display: flex;margin-top: 20px;">
						<el-radio v-model="userget" label="2">有</el-radio>
						<div style="margin-top: -13.5px;">
							<span style="margin-right:10px;">分享者可获得</span>
							<el-input size="small" type="number" style="width: 120px;" v-model="sharemoney"></el-input>
							<span style="margin-left:10px;">天会员</span>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div class="button_s">
				<el-button type="primary" size="small">保存</el-button>
			</div>
		</div>
		<div class="wai2">
			<div class="demo2">
				<div class="img1">
					<img src="../../../assets/head.png" />
				</div>
				<p>用户昵称</p>
				<div class="img2">
					<img src="../../../assets/erwei.png" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import upload from "../../compents/upload/upload.vue"
	export default {
		components: {
			upload
		},
		data() {
			return {
				options: [],
				userhead: "",
				usercolor: "",
				userget: "",
				ljie: "", //外部连接
				checkedCities: [], //复选框
				radio1_data: "",
				radio1_time: "", //选项一绑定的时间
				cheosepeo: "",
				updatemethod: "", //更新方式
				radio: "",
				textAreaVal: "",
				labelname: "",
				ljnamelngth: 0,
				ljname: "",
				sharemoney: "" //分享获得奖励
			}
		},
		computed: {},
		watch: {
			// 监听value的变化
			// value: {
			//   handler(val, oldVal) {
			//     this.textAreaVal = val
			//   },
			//   immediate: true
			// }
		},
		methods: {}
	};
</script>
<style lang="less" scoped>
	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 32%;
	}

	.button_s {
		margin-left: 100px;
	}

	// 
	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	.heads {
		line-height: 1;
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	.wai2 {
		margin: auto;

		.demo2 {
			width: 308px;
			height: 528px;
			background: #ECECEC;
			border-radius: 10px;
			padding-top: 30px;
			box-sizing: border-box;

			.img1 {
				width: 94px;
				height: 94px;
				border-radius: 7px;
				overflow: hidden;
				margin: auto;

				img {
					width: 100%;
					height: 100%;
				}
			}

			p {
				width: 100%;
				text-align: center;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #3E3E3E;
			}

			.img2 {
				width: 96px;
				height: 97px;
				border-radius: 7px;
				overflow: hidden;
				margin: auto;
				margin-top: 200px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	// <div class="demo2">
	// 				     <img   src="../../../assets/head.png"  class="img1" />
	// 					 <p>用户昵称</p>
	// 					 <img src="../../../assets/erwei.png" class="img2" />
	// </div>
</style>